module.exports = __webpack_public_path__ + "img/ic-new-window-pink.360b57b0.svg";